import styled from "styled-components";

export const AppWrapper = styled.div`
  .App {
    text-align: center;
  }

  .App-logo {
    height: 40vmin;
    pointer-events: none;
  }

  @media (prefers-reduced-motion: no-preference) {
    .App-logo {
      animation: App-logo-spin infinite 20s linear;
    }
  }

  .App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
  }

  .App-link {
    color: #61dafb;
  }

  h1 {
    color: #fff;
  }

  @font-face {
    font-family: "Avenir";
    src: local("Avenir"),
      url("./fonts/avenir_ff/AvenirLTStd-Black.otf") format("truetype");
    font-weight: bold;
  }

  @font-face {
    font-family: "Avenir Light";
    src: local("Avenir Light"),
      url("./fonts/avenir_ff/AvenirLTStd-Book.otf") format("truetype");
    font-weight: bold;
  }

  body {
    font-family: "Avenir", -apple-system, BlinkMacSystemFont, "Segoe UI",
      "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
      "Helvetica Neue", sans-serif !important;
  }

  @keyframes App-logo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
